import type { RouteRecordRaw } from 'vue-router';
import { verifyRoutePermission } from '@/router/guard';

export const WhatsAppRoutes: RouteRecordRaw[] = [
    {
        path: '',
        name: 'whatsappManagement',
        component: () => import('./Index.vue'),
        beforeEnter: verifyRoutePermission,
        meta: { permission: 'whatsapp.access' }
    }
];
